export default __webpack_public_path__ + "static/media/icons8-refresh-500.3be7382e.png";